// packages
import 'intersection-observer';
import yall from 'yall-js';

// local imports
import { AdLoader } from './ads/loader';
// import { lottie } from '.lottie';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

// Write your code!
console.log('Hello, world!');

function drawBlocks(num, div, name) {
  for (var i = 0; i < num; i++) {
    $('.' + div).append("<div class='acre_block block_" + name + "'></div>");
  }
}

drawBlocks(320, 'block_now', '2020');
drawBlocks(760, 'block_now', 'pastdecade');
drawBlocks(703, 'block_prev', 'block_prev');
drawBlocks(78, 'yosemite', 'yosemite');
// drawBlocks(3, 'sanfran', 'sanfran');
